import gql from "graphql-tag";
import get from "lodash/get";
import { isDesktop, isMobile } from "shared/util/EnvironmentHelpers";
import isApp from "shared/util/isApp";

export const CREATE_TSP_TOKEN = gql`
	mutation authTSPAccessTokenCreate {
		authTSPAccessTokenCreate {
    		tspAccessToken
  		}
	}
`;

export const getToken = (data) => get(data, "data.authTSPAccessTokenCreate.tspAccessToken");

// platforms to send with AuthOTPSendInput
export const PLATFORMS = {
	WEB: "web",
	MOBILE_WEB: "mobile_web",
};

export const getPlatformForSms = () => {
	let platform;

	if (isDesktop) {
		platform = PLATFORMS.WEB;
	} else if (isMobile && !isApp()) {
		platform = PLATFORMS.MOBILE_WEB;
	}

	return platform;
};

export const SEND_OTP_CODE = gql`
	mutation authOTPSend($input: AuthOTPSendInput!) {
		authOTPSend(input: $input) {
    		success
  		}
	}
`;

export const getOTPSendSuccess = (data) => get(data, "data.authOTPSend.success");

export const CREATE_REFRESH_TOKEN = gql`
	mutation authTSPRefreshTokenCreate($input: AuthTSPRefreshTokenCreateInput!) {
		authTSPRefreshTokenCreate(input: $input) {
    		tspRefreshToken
  		}
	}
`;

export const getTspRefreshToken = (data) => get(data, "data.authTSPRefreshTokenCreate.tspRefreshToken");

export const LOG_IN_WITH_SMS = gql`
	mutation authUserLoginWithSMS($input: AuthUserLoginWithSMSInput!) {
		authUserLoginWithSMS(input: $input) {
			userid
			statusCode
			reenableAuthCode
			reenableUserid
		}
	}
`;

export const LOG_IN_WITH_EMAIL = gql`
	mutation authUserLoginWithEmail($input: AuthUserLoginWithEmailInput!) {
		authUserLoginWithEmail(input: $input) {
			userid
			statusCode
			reenableAuthCode
			reenableUserid
			onboardingIncomplete
		}
	}
`;

export const REENABLE_ACCOUNT = gql`
	mutation authUserLoginReenable($input: AuthUserLoginReenableInput!) {
		authUserLoginReenable(input: $input) {
			userid
			statusCode
			reenableAuthCode
			reenableUserid
			onboardingIncomplete
		}
	}
`;

export const getUserid = (data) => get(data, "data.authUserLoginWithSMS.userid");

export const getStatusCode = (data) => get(data, "data.authUserLoginWithSMS.statusCode");

export const getSmsLoginResponse = (data) => get(data, "data.authUserLoginWithSMS");

export const getEmailLoginResponse = (data) => get(data, "data.authUserLoginWithEmail");

export const getReenableLoginResponse = (data) => get(data, "data.authUserLoginReenable");

export const USER_SEND_OTP_SMS = gql`
	mutation userSendOtpSms($input: UserSendOtpSmsInput!) {
		userSendOtpSms(input: $input) {
			success
			statusCode
		}
	}
`;

export const getUserSendOTPSuccess = (data) => get(data, "data.userSendOtpSms.success");

export const USER_VALIDATE_SEND_OTP_SMS = gql`
	mutation UserValidateOtpSms($input: UserValidateOtpSmsInput!) {
		userValidateOtpSms(input: $input) {
			tspRefreshToken
			statusCode
		}
	}
`;

export const getUserTspRefreshToken = (data) => get(data, "data.userValidateOtpSms.tspRefreshToken");

export function graphqlLoginPayloadToLegacy(res = {}) {
	return {
		userid: res.userid,
		status: res.statusCode,
		reenable_authcode: res.reenableAuthCode,
		reenable_userid: res.reenableUserid,
		onboarding_incomplete: res.onboardingIncomplete,
	};
}



// WEBPACK FOOTER //
// ./src/apps/login/util/mutations.js